import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'react-bootstrap';
import IconButton from 'components/common/IconButton';
import entete from 'data/entetes';

function LignesModal({ modalShow, setModalShow, NfactLignes }) {
  const [lignes, setLignes] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      if (modalShow) {
        const lignesData = await entete.getLignes(NfactLignes);
        if (lignesData) {
          setLignes(lignesData);
          setLoading(false);
        }
      }
    };

    fetchData();
  }, [modalShow]);

  return (
    <>
      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header style={{ justifyContent: 'space-between' }}>
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={{ fontSize: '1.25rem' }}
          >
            Détails Transaction {NfactLignes.nfact}
          </Modal.Title>

          <IconButton
            className="btn btn-circle btn-sm transition-base p-0 primary"
            iconClassName="text-black"
            icon="window-close"
            size="sm"
            onClick={() => setModalShow(false)}
          />
        </Modal.Header>
        <Modal.Body>
          {loading ? (
            <p>Loading...</p>
          ) : (
            <div style={{ maxHeight: '50vh', overflowY: 'auto' }}>
              <table
                className="table table-striped"
                style={{ fontSize: '0.8rem' }}
              >
                <thead>
                  <tr>
                    <th>Produit</th>
                    <th>Code Produit</th>
                    <th>Quantité</th>
                    <th>PU HT</th>
                    <th>TVA</th>
                    <th>Montant</th>
                    <th>Promo</th>
                  </tr>
                </thead>
                <tbody>
                  {lignes.map(ligne => (
                    <tr key={ligne.id}>
                      <td>{ligne.produit}</td>
                      <td>{ligne.codeproduit}</td>
                      <td>{ligne.qte}</td>
                      <td>{ligne.puht}</td>
                      <td>{ligne.tva}</td>
                      <td>{ligne.mntdt}</td>
                      <td>{ligne.promo}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setModalShow(false)}>Close</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

LignesModal.propTypes = {
  modalShow: PropTypes.bool,
  setModalShow: PropTypes.func,
  NfactLignes: PropTypes.object
};

export default LignesModal;
